import { Tooltip } from "radix-ui";

export const BasicTooltip = ({
  triggerContent,
  content,
}: {
  triggerContent: JSX.Element;
  content: string;
}) => {
  return (
    <Tooltip.Provider delayDuration={150}>
      <Tooltip.Root>
        <Tooltip.Trigger className="h-fit rounded-l-full rounded-r-full bg-primary-900 text-sm text-primary-950 duration-150 data-[state=delayed-open]:bg-primary-950 data-[state=delayed-open]:text-primary-50 data-[state=instant-open]:bg-primary-950 data-[state=instant-open]:text-primary-50">
          {triggerContent}
        </Tooltip.Trigger>
        <Tooltip.Content className="rounded-2xl border border-neutral-500 bg-neutral-950 p-4 text-xs text-neutral-100 animate-in fade-in-0 zoom-in-95 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95">
          {content}
          <Tooltip.Arrow
            className="z-10 -translate-y-0.5 fill-neutral-950"
            width={23}
            height={12}
          />
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
